import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useGetWalletBalanceQuery, useCreateWalletMutation } from "../../../service/charge-service";
import { FailedToLoadData } from "../../../common/components/failed-to-load-data/FailedToLoadData";
import CustomerPageLayout from "../customer-page-layout/CustomerPageLayout";
import WalletOnboardingScreen from "./wallet-onboarding-screen/WalletOnboardingScreen";
import { WalletLoadingSkeleton } from "./WalletLoadingSkeleton";
import { WalletTermsOfUseModal } from "./modals/wallet-terms-of-use/WalletTermsOfUseModal";
import { WalletActiveScreen } from "./wallet-active-screen/WalletActiveScreen";

export const WalletPage = () => {
	const { t } = useTranslation();
	const { data, isFetching, error } = useGetWalletBalanceQuery(undefined, { refetchOnMountOrArgChange: true });
	const [createWallet, { isLoading: isCreating }] = useCreateWalletMutation();
	const [isTermsOpen, setIsTermsOpen] = useState(false);
	const [showCreatedBanner, setShowCreatedBanner] = useState(false);
	const [justCreatedWallet, setJustCreatedWallet] = useState(false);

	useEffect(() => {
		if (data) setJustCreatedWallet(false);
	}, [data]);

	const handleAcceptTerms = async () => {
		try {
			await createWallet().unwrap();
			setJustCreatedWallet(true);
			setIsTermsOpen(false);
			setShowCreatedBanner(true);
			setTimeout(() => setShowCreatedBanner(false), 3000);
		} catch {
			toast.error(t("wallet.web.failedToCreateWallet"));
		}
	};

	const hasWallet = Boolean(data?.walletDetails.length);

	const renderContent = () => {
		if ((isFetching && data === undefined) || (isFetching && justCreatedWallet)) return <WalletLoadingSkeleton />;
		if (error) return <FailedToLoadData text={t("wallet.failedToLoadWalletData")} />;
		if (data !== undefined && !hasWallet) return <WalletOnboardingScreen onContinue={() => setIsTermsOpen(true)} />;
		if (hasWallet) return <WalletActiveScreen data={data!} showCreatedBanner={showCreatedBanner} />;
		return <WalletLoadingSkeleton />;
	};

	return (
		<>
			<CustomerPageLayout
				title={t("common.labels.wallet")}
				showBackButton={true}
				contentMaxWidth={1200}
				isScrollable
			>
				{renderContent()}
			</CustomerPageLayout>
			{isTermsOpen && (
				<WalletTermsOfUseModal
					isCreating={isCreating}
					onClose={() => !isCreating && setIsTermsOpen(false)}
					onAccept={handleAcceptTerms}
				/>
			)}
		</>
	);
};
